export default __webpack_public_path__ + "static/media/The Death of Innocents.129ea77b.jpg";